var productGridContainer = document.querySelector('#main-collection-product-grid');
const pagination = document.querySelector('.pagination');
const paginationItems = pagination ? pagination.querySelectorAll('li') : [];
const lastPageItem = paginationItems[paginationItems.length - 2];
const sortBy = document.querySelector('#SortBy');
let currentPage = 1;
let loading = false;
let sortOption = '';
let sortParameter = window.location.search.slice(1);

function updateNextLink() {
  currentPage = 1;
  searchParams = new URLSearchParams(window.location.search);
  searchParams.set('sort_by', sortOption);
  const nextLink = `${searchParams.toString()}`;
  return nextLink;
}

function loadMore() {
  if (!loading) {
    loading = true;
    const nextPage = currentPage + 1;
    const nextLink = `${window.location.pathname}?page=${nextPage}&${sortParameter}`;
    fetch(nextLink)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const parsedHtml = parser.parseFromString(html, 'text/html');
        const collectionProducts = parsedHtml.querySelector('#CollectionProductGrid');
        const productGrid = collectionProducts.querySelector('#main-collection-product-grid');
        const newProducts = productGrid.querySelectorAll('.product-item');
        if (newProducts.length) {
          newProducts.forEach(newProduct => {
            productGridContainer.appendChild(newProduct);
          });
          currentPage = nextPage;
          loading = false;
        } else {
          lastPageItem.classList.add('disabled');
        }
      })
      .catch(error => console.log(error));
  }
}

if (pagination && lastPageItem) {
  window.addEventListener('scroll', () => {
    const { scrollTop, clientHeight } = document.documentElement;
    productGridContainer = document.querySelector('#main-collection-product-grid');
    if (scrollTop + clientHeight >= productGridContainer.offsetTop + productGridContainer.offsetHeight) {
      loadMore();
    }
  });
}

sortBy.addEventListener('change', (event) => {
  sortOption = event.target.value;
  sortParameter = updateNextLink();
});